// ProcessingOverlay.jsx
import React from "react";

const ProcessingOverlay = ({ contentWidth, sideBarMode }) => {
  return (
    <div
      className="fixed flex items-center justify-center z-[100]"
      style={{
        width: contentWidth,
        left: sideBarMode ? 0 : "50%",
        transform: sideBarMode ? "none" : "translateX(-50%)",
        height: "100%",
      }}
    >
      <div className="rounded-lg bg-black bg-opacity-80 text-white p-12 flex flex-col items-center justify-center">
        <div className="text-center text-white">
          <div className="flex items-center justify-center">
            <div className="relative w-16 h-16 animate-spin-slow">
              {[...Array(12)].map((_, i) => (
                <span
                  key={i}
                  className="absolute left-1/2 top-1/2 block w-1 h-3 bg-white rounded animate-spinner-bar"
                  style={{
                    transform: `rotate(${i * 30}deg) translate(0, -150%)`,
                    animationDelay: `${i * 0.1}s`,
                  }}
                />
              ))}
            </div>
          </div>

          <h2 className="text-heroFontSize font-medium mb-2 mt-2 text-white">
            We are analyzing your response… Just a moment.
          </h2>
        </div>
      </div>
    </div>
  );
};

export default ProcessingOverlay;
